import React, { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { IconCTA } from 'Src/components/buttons/IconCTA';
import Copy from 'Src/components/Copy';
import { Divider } from 'Src/feature/divider/Divider';
import { useResize } from 'Src/feature/resize/useResize';
import { useSignature } from 'Src/feature/signature/useSignature';

import styles from './FlipAndTipSignature.module.scss';

interface FlipAndTipSignatureProps {
  signature: ReturnType<typeof useSignature>;
  canvasRef: RefObject<HTMLCanvasElement> | RefObject<undefined>;
}

const FlipAndTipSignature: FC<FlipAndTipSignatureProps> = ({
  signature,
  canvasRef,
}) => {
  const { t } = useTranslation();
  
  useResize({
    // document.body
    // - used to set up initial canvas size
    // - used to avoid infinite renders when changing size of canvas
    element: document.body,
    onResize: () => {
      // bind canvas width to the width of its container
      if (canvasRef.current && canvasRef.current?.parentElement) {
        canvasRef.current.width = canvasRef.current.parentElement.clientWidth;
      }
    }
  });

  return (
    <div className={styles.root}>
      <div className={styles.canvas_wrapper}>
        <canvas
          ref={canvasRef as RefObject<HTMLCanvasElement>}
          className={styles.canvas}
        />
        <div className={styles.canvas_overlay_graphic}>
          <Divider />
          <Copy value={t('flipAndTip.labels.signHere')} variant="caption" disabled />
        </div>
        <IconCTA
          className={styles.action_left}
          icon="close"
          variant="no-background"
          size="xs"
          onClick={() => {
            signature.clear();
          }}
        />
      </div>
    </div>
  );
};

export { FlipAndTipSignature };
